import { Divider, Dropdown } from 'antd';
import React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import styled from 'styled-components';

type Props = {
  menu?: JSX.Element;
  filterTitle?: string,
  filterIcon?: JSX.Element;
  iconMode?: boolean,
  isActive?: boolean,
} | typeof defaultProps;

const defaultProps = {
  menu: <div />,
  filterTitle: '',
  filterIcon: null,
  iconMode: false,
  isActive: false,
};

const Wrapper = styled.div`
  .iconModeActive {
    padding: 0px;
    border: none;
    padding-top: 5px;
    margin-left: 20px;
    &:hover {
      outline : none;
      border: none;
    }
    .ant-divider, .anticon-caret-down {
      display: none;
    }
  }
  .active{
    background: #DEF6E6 !important;
    color: #09A43A;
  }
`;

const DropdownFilter = function DropdownFilter(props: Props) {
  const {
    menu, filterTitle, filterIcon, iconMode, isActive,
  } = props;
  return (
    <Wrapper>
      <Dropdown
        placement="bottomRight"
        overlay={menu || <div />}
        trigger={['click']}
        className="tabs-wrapper c-pointer"
        getPopupContainer={(e: HTMLElement) => e}
        overlayClassName="filter-dropdown"
      >
        <span
          className={classNames('d-flex align-items-center tabs-item global-tabs-item', { iconModeActive: iconMode }, { active: isActive })}
          onClick={(e) => e.preventDefault()}
          onKeyDown={(e) => e.preventDefault()}
          role="button"
          aria-label="Filters"
          tabIndex={0}
        >
          {filterIcon || filterTitle}
          <Divider type="vertical" />
          <CaretDownOutlined />
        </span>
      </Dropdown>
    </Wrapper>

  );
};

DropdownFilter.defaultProps = defaultProps;
export default DropdownFilter;
